import React, { ReactElement } from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../../shared/components/table-components';
import { SortButtons } from '../../../../../shared/components/buttons';
import classes from './TitleRow.module.scss';
import { unreadScansStore } from '../../../../stores/unreadScansStore';
import { UNREAD_SCANS_COLUMN, UnreadScansColumn } from '../UnreadScansTable.settings';

type TitleRowProps = {
  visibleColumns: UnreadScansColumn[];
};

const TitleRow = observer(({ visibleColumns }: TitleRowProps) => {
  const { filterMethods } = unreadScansStore;
  const { handleSort, getIsSortedBy } = filterMethods;

  const renderColumnsInfo: Record<UnreadScansColumn, ReactElement> = {
    [UNREAD_SCANS_COLUMN.NAME]: (
      <GridTableCell>
        <SortButtons
          fieldName="CUSTOMER_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Name
        </SortButtons>
      </GridTableCell>
    ),
    [UNREAD_SCANS_COLUMN.SOLUTION]: (
      <GridTableCell>
        <SortButtons
          fieldName="SOLUTION_TYPE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Solution
        </SortButtons>
      </GridTableCell>
    ),
    [UNREAD_SCANS_COLUMN.COACH]: (
      <GridTableCell>
        <SortButtons
          fieldName="COACH_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Coach
        </SortButtons>
      </GridTableCell>
    ),
    [UNREAD_SCANS_COLUMN.ACTIVE_SINCE]: (
      <GridTableCell>
        <SortButtons
          fieldName="ACTIVE_SINCE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Active Since
        </SortButtons>
      </GridTableCell>
    ),
    [UNREAD_SCANS_COLUMN.DATE_OF_UPDATE]: (
      <GridTableCell justify="end">Date of Update</GridTableCell>
    ),
  };

  return (
    <GridTableRow variant="unstyled" className={classes.titleRow}>
      {visibleColumns.map((column) => (
        <React.Fragment key={column}>{renderColumnsInfo[column]}</React.Fragment>
      ))}
    </GridTableRow>
  );
});

export { TitleRow };
